"use strict";

import { Text } from "@citifyd/style";
import classNames from "classnames";
import { useTranslator } from "../../../../shared/react/hooks";
import styles from "./Properties.module.scss";

const BreakdownSublist = ({ items, style }) =>  (
  Array.isArray(items) && items.length > 0 && (
    <ul className={styles.breakdownSublist}>
      {items.map((item, idx) => (
        <li key={item.label + idx} className={classNames(style)}>
          <Text>{item.label}: {item.count}</Text>
        </li>
      ))}
    </ul>
  )
);

const Breakdown = ({ property, anyLotHasLongTermParkingPlan, ...rest }) => {
  const t = useTranslator();
  return (
    <div {...rest}>
      <Text
        className={classNames(styles.breakdownTitle, styles.spaces)}
        variant="subtitle"
        textAlign="center"
        dangerouslySetInnerHTML={{
          __html: t("propertySnapshot.totalSpaces", {
            occupied: property?.occupied,
            count: property?.maxSpots,
            startBold: "<strong>",
            endBold: "</strong>",
          }),
        }}
      />
      <Text className={classNames(styles.legendColor, styles.space)}>
        {t("propertySnapshot.availableSpaces", {
          count: property?.available,
        })}
      </Text>
      <Text className={classNames(styles.legendColor, styles.ondemand)}>
        {t("propertySnapshot.onDemandParkers", {
          count: property?.onDemandParkersCount,
        })}
      </Text>
      <BreakdownSublist items={property?.onDemandParkersBreakdown} style={styles.ondemand} />
      <Text className={classNames(styles.legendColor, styles.permit)}>
        {t("propertySnapshot.permitParkers", {
          count: property?.permitPassCount,
        })}
      </Text>
      <Text className={classNames(styles.legendColor, styles.reservedparking)}>
        {t("propertySnapshot.reservedParkingParkers", {
          count: property?.reservedParkingCount,
        })}
      </Text>
      {anyLotHasLongTermParkingPlan && (
        <>
          <Text className={classNames(styles.legendColor, styles.monthly)}>
            {t("propertySnapshot.monthlyParkers", {
              count: property?.monthlyParkersCount,
            })}
          </Text>
          <BreakdownSublist items={property?.monthlyParkersBreakdown} style={styles.monthly} />
        </>
      )}
      <Text className={classNames(styles.legendColor, styles.purchased)}>
        {t("propertySnapshot.eventPassesPurchased", {
          count: property?.pendingTicketsPurchasedCount,
        })}
      </Text>
      <BreakdownSublist items={property?.ticketsPurchasedBreakdown} style={styles.purchased} />
      <Text className={classNames(styles.legendColor, styles.parked)}>
        {t("propertySnapshot.eventPassesParked", {
          count: property?.ticketsParkedCount,
        })}
      </Text>
      <BreakdownSublist items={property?.ticketsParkedBreakdown} style={styles.parked} />
    </div>
  );
};

export default Breakdown;
